import React, {useState, useEffect} from "react";
import {Outlet} from "react-router-dom";
import Sidebar from "../components/common/Sidebar";
import AppBar from "../components/common/AppBar";
import NotificationCenter from "../components/common/NotificationCenter";
import {Box, useTheme, useMediaQuery} from "@mui/material";
import {getUnreadCount} from "../api/notification";

const MainLayout: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [isSidebarOpen, setSidebarOpen] = useState(!isMobile);
  const [notificationCenterOpen, setNotificationCenterOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const handleDrawerToggle = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const handleNotificationClick = () => {
    setNotificationCenterOpen(true);
  };

  const handleNotificationClose = () => {
    setNotificationCenterOpen(false);
  };

  // Load unread count on mount and when notification center opens/closes
  useEffect(() => {
    const loadUnreadCount = async () => {
      try {
        const response = await getUnreadCount();
        setUnreadCount(response.count);
      } catch (error) {
        console.error("Error loading unread count:", error);
      }
    };

    loadUnreadCount();

    // Refresh unread count when notification center closes
    if (!notificationCenterOpen) {
      loadUnreadCount();
    }
  }, [notificationCenterOpen]);

  return (
    <Box display="flex" minHeight="100vh">
      <Sidebar isSidebarOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen} handleDrawerToggle={handleDrawerToggle} isMobile={isMobile} />
      <Box flexGrow={1} display="flex" flexDirection="column">
        <AppBar handleDrawerToggle={handleDrawerToggle} onNotificationClick={handleNotificationClick} unreadCount={unreadCount} />
        <Box
          flexGrow={1}
          p={{xs: 2, sm: 3}}
          pr={{xs: 3, sm: 6}}
          bgcolor="#f5f6fa"
          sx={{overflowX: "auto", maxWidth: "100vw", boxSizing: "border-box"}}>
          <Outlet />
        </Box>
      </Box>
      <NotificationCenter open={notificationCenterOpen} onClose={handleNotificationClose} />
    </Box>
  );
};

export default MainLayout;
